export const AppsBudget = () => (
  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M20 6C20 8.626 15.976 10 12 10C8.024 10 4 8.626 4 6C4 3.374 8.024 2 12 2C15.976 2 20 3.374 20 6ZM12 14C8.024 14 4 12.626 4 10V8C4 10.626 8.024 12 12 12C15.976 12 20 10.626 20 8V10C20 12.626 15.976 14 12 14ZM4 14C4 16.626 8.024 18 12 18C15.976 18 20 16.626 20 14V12C20 14.626 15.976 16 12 16C8.024 16 4 14.626 4 12V14ZM12 22C8.024 22 4 20.626 4 18V16C4 18.626 8.024 20 12 20C15.976 20 20 18.626 20 16V18C20 20.626 15.976 22 12 22Z'
      fill='inherit '
    />
  </svg>
);
